import React from "react";
import "./HRCopilotTestimonial.css";

const HRCopilotTestimonial = () => {
  return (
    <section className="hrt-section">

      {/* LEFT IMAGE SHAPE */}
      <div className="hrt-left">
        <div className="hrt-image-wrapper">
          <img
            src="/images/tim8.png"
            alt="testimonial"
            className="hrt-image"
          />

          {/* Decorative shapes */}
          <div className="hrt-deco-shape hrt-deco-1"></div>
          <div className="hrt-deco-shape hrt-deco-2"></div>
        </div>
      </div>

      {/* RIGHT CONTENT */}
      <div className="hrt-right">

        <p className="hrt-subtitle">GREAT REVIEWS FOR OUR SERVICES</p>

        <h2 className="hrts-title">
          Trusted by Biggest <br />
          <span>Business Names</span>
        </h2>

        <p className="hrt-desc">
          Our clients have always trusted our expertise and advices. 
          Here’s what they have to say about us.
        </p>

        <div className="hrt-quote-block">
          <span className="hrt-quote-icon">“</span>
          <p className="hrt-quote-text">
            Scallop and sarcastic opossum crudely hey ape one one hello 
            lucrative far implacable sighed consoled apart across hatchet.
          </p>
        </div>

        <div className="hrt-author">
          <h4>John Hopkins</h4>
          <p>Applauz Startup</p>
        </div>

      </div>
    </section>
  );
};

export default HRCopilotTestimonial;
